module.exports = __webpack_public_path__ + "img/card-el-8.e44d726c.svg";